<script>
export default {
    props: [],
    data() {
        return {
            showModal: false,
            reminder_type_option: [
                { id: 0, name: 'Time of event' },
                { id: 10, name: '10 minutes before' },
                { id: 60, name: 'Hour before' },
                { id: 1440, name: 'One day before' },
                { id: 10080, name: 'Seven days before' },
            ],
            item_type_options: {
                home_game: 'Home Game',
                road_game: 'Road Game',
                other: 'General Event',
                reminder: 'Reminder',
            },
            form: new SparkForm({
                name: null,
                reminds: [],
                reminder: null,
                start_date: null,
                start_time: null,
                disclaimer: null,
                opponent: null,
                date_type: null,
                item_type: null,
            }),
        };
    },
    methods: {
        clearForm() {
            this.form.opponent = null;
            this.form.date_type = null;
            this.form.item_type = null;
            this.form.reminder_type = null;
            this.form.name = null;
            this.form.start_date = null;
            this.form.time = null;
        },
        submit() {
            const _this = this;
            if (this.form.item_type === 'reminder') {
                Spark.post('/api/tasks', this.form).then((response) => {
                    _this.showModal = false;
                    _this.clearForm();
                    Bus.$emit('allCalendarsRefetch');
                });
            } else {
                this.form.date_type = this.form.item_type;
                Spark.post('/api/team/schedule-dates', this.form).then((response) => {
                    _this.showModal = false;
                    _this.$noty.success('Event Added');
                    _this.clearForm();
                    Bus.$emit('allCalendarsRefetch');
                });
            }
        },
    },
};
</script>
